"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _DialogBody = require("../../components/DialogBody/DialogBody.styles");
var _DialogFooter = require("../../components/DialogFooter/DialogFooter.styles");
var _DialogHeader = require("../../components/DialogHeader/DialogHeader.styles");
var _DialogLayout = require("../../components/DialogLayout/DialogLayout.styles");
var _DropdownHeading = require("../../components/DropdownHeading/DropdownHeading.styles");
var _overflowAutoMixin = require("../overflowAutoMixin");
var _overflowPaddingMixin = require("../overflowPaddingMixin");
var _DialogMixin = require("./DialogMixin");
/** @class DropdownMixin */
/**
 * Standalone styles for a dropdown component.
 *
 * @example
 * import { DropdownMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${DropdownMixin}
 * `;
 *
 * <Component>My dropdown component</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var DropdownMixin = function DropdownMixin(props) {
  return (0, _styledToken.default)({
    zIndex: 'Dropdown.zIndex',
    borderRadius: 'Dropdown.borderRadius',
    horizontalSpacing: 'Dropdown.horizontalSpacing',
    verticalSpacing: 'Dropdown.verticalSpacing',
    footerMargin: 'Dropdown.Footer.margin'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing,
      footerMargin = _ref.footerMargin,
      zIndex = _ref.zIndex;
    return (0, _styledComponents.css)(["", " z-index:", ";border-radius:", "px;", "{display:flex;flex-direction:column;}", "{flex:0 0 auto;}", "{", " ", ";flex:1 1 auto;> ", "{margin-left:-", ";margin-right:-", ";&:first-child{margin-top:-", ";}}}", "{flex:0 0 auto;align-items:center;box-sizing:border-box;display:flex;justify-content:flex-end;margin:", "px;padding:", "px ", "px;}"], (0, _DialogMixin.DialogMixin)(props), zIndex, borderRadius, _DialogLayout.StyledDialogLayout, _DialogHeader.StyledDialogHeader, _DialogBody.StyledDialogBody, (0, _overflowAutoMixin.overflowAutoMixin)(props), (0, _overflowPaddingMixin.overflowPaddingMixin)(verticalSpacing + "px", horizontalSpacing + "px", verticalSpacing + "px"), _DropdownHeading.StyledDropdownHeading, horizontalSpacing + "px", horizontalSpacing + "px", verticalSpacing + "px", _DialogFooter.StyledDialogFooter, footerMargin, verticalSpacing, horizontalSpacing);
  })(props);
};
exports.DropdownMixin = DropdownMixin;